import NotificationsDashboard from './NotificationsDashboard'

export default NotificationsDashboard
